import css from '../pages/presenze/calendarioPresenze_WF.module.css'
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import TagIconFilled from "../icons/TagIconFilled";

interface BadgeProps {
    label: string | null,
    fillColor?: string,
    size?: number,
    getGiustificativo: GiustificativoRecord | null,
}

const BadgeGiustificativi: React.FC<BadgeProps> = ({label, fillColor = 'currentColor', size = 15, getGiustificativo}) => {
    const getBgColorGiustificativo = function (codGiu: string | null) {
        if (codGiu) {
            let giustificativo = getGiustificativo;
            if (giustificativo && giustificativo.bgColor) {
                return giustificativo.bgColor
            } else return '#fff'
        } else return '#fff'
    }

    const codGiu = (getGiustificativo && getGiustificativo.codGiu) ? getGiustificativo.codGiu : null;

    return (
        <div className={`${css.badgeGiuCausaliWF}`} style={{backgroundColor: getBgColorGiustificativo(codGiu)}}>
            <TagIconFilled className="size-3 md:size-3.5" style={{color: fillColor}}/>
            <span className="whitespace-nowrap">{label ? label : '????'}</span>
        </div>
    )
}
export default BadgeGiustificativi;


